<template>
    <div>

        <Card>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch" />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">存货仓管理</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['H'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreate">新增</Button>

                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16"
                class="row-margin-top-10">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
        <Modal v-model="formShow"
            title="仓库信息">
            <Form ref="warehouseForm"
                :model="form"
                :rules="ruleValidate"
                label-position="top"
                class="small-form border">
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="存货仓名称"
                        prop="warehouseName">
                        <Input v-model="form.warehouseName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="负责人"
                        prop="warehouseContacts">
                        <Input v-model="form.warehouseContacts"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="手机"
                        prop="warehousePhone">
                        <Input v-model="form.warehousePhone"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="存货仓地址">
                        <Input v-model="form.warehouseAddress"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button v-if="$checkAccessArray(['H'])"
                    type="primary"
                    @click="onSave">确认
                </Button>
                <Button type="error"
                    @click="formShow = false">取消
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import search from '@/libs/search';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import { getWarehouseList, saveWarehouse } from '@/api/modules/warehouse-management/warehouse';

export default {
    name: 'WarehouseList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '名称', key: 'warehouseName', align: 'center' },
                    { title: '负责人', key: 'warehouseContacts', align: 'center' },
                    { title: '手机', key: 'warehousePhone', align: 'center' },
                    { title: '地址', key: 'warehouseAddress', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onUpdate(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '名称', type: 'Input', value: '', name: 'warehouseName', sql: 'like' }
                ]
            },
            form: {
                formEditMode: '',
                warehouseUuid: '',
                warehouseName: '',
                warehouseAddress: '',
                warehouseContacts: '',
                warehousePhone: ''
            },
            formShow: false,
            ruleValidate: {
                warehouseName: [{ required: true, message: ' ', trigger: 'blur' }],
                warehouseContacts: [{ required: true, message: ' ', trigger: 'blur' }],
                warehousePhone: [{ required: true, message: ' ', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getWarehouseList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onCreate() {
            this.form.formEditMode = FORM_EDIT_MODE_CREATE;

            this.form.warehouseUuid = '';
            this.form.warehouseName = '';
            this.form.warehouseAddress = '';
            this.form.warehouseContacts = '';
            this.form.warehousePhone = '';

            this.formShow = true;
        },
        onUpdate(row) {
            this.form.formEditMode = FORM_EDIT_MODE_MODIFY;

            this.form.warehouseUuid = row.warehouseUuid;
            this.form.warehouseName = row.warehouseName;
            this.form.warehouseAddress = row.warehouseAddress;
            this.form.warehouseContacts = row.warehouseContacts;
            this.form.warehousePhone = row.warehousePhone;

            this.formShow = true;
        },
        onSave() {
            this.$refs.warehouseForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({}, this.form);

                this.$Spin.show();
                saveWarehouse(data).then(res => {
                    this.$Spin.hide();

                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            content: '',
                            onOk: () => {
                                this.formShow = false;
                                this.init();
                                // window.location.reload();
                            }
                        });
                    }
                }).catch(() => {
                    this.$Spin.hide();
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
